import React from 'react';
import { FastField as FormikField } from 'formik';
import { MultiSelectGroup, Checkbox } from '@xo-union/tk-component-switches';
import { Event } from '../interfaces';
import styles from './styles.scss';

interface EventSelectorProps {
  formikName: string;
  events: Event[];
}

const CheckboxGroup = ({
  field,
  form,
  events,
  formikName,
}: {
  field: any;
  form: any;
  events: Event[];
  formikName: string;
}): React.ReactElement => {
  const onClick = (e: any): void => {
    const fieldValue = [...field.value];
    const targetId = e.target.value;

    const foundIndex = fieldValue.findIndex(({ eventId }) => eventId === targetId);
    if (foundIndex > -1) {
      fieldValue.splice(foundIndex, 1);
    } else {
      fieldValue.push({ eventId: targetId, rsvp: null });
    }

    form.setFieldValue(field.name, fieldValue);
  };

  const values = React.useMemo(() => field?.value?.map(({ eventId }: { eventId: string }) => eventId) || [], [field]);

  return (
    <MultiSelectGroup values={values} onChange={onClick}>
      {events.map(e => {
        const uniqId = `${formikName}${e.id}`;
        return (
          <Checkbox key={uniqId} id={uniqId} value={e.id}>
            <span className={styles.checkboxLabel}>{e.name}</span>
          </Checkbox>
        );
      })}
    </MultiSelectGroup>
  );
};

const EventSelector: React.FC<EventSelectorProps> = ({ formikName, events }) => {
  return (
    <>
      <div className={styles.eventSelectorLabel}>Invited to the following events:</div>
      <div className={styles.eventSelectorContainer}>
        <FormikField name={formikName}>
          {({ field, form }: { field: any; form: any }): React.ReactElement => (
            <CheckboxGroup field={field} form={form} events={events} formikName={formikName} />
          )}
        </FormikField>
      </div>
    </>
  );
};

export default EventSelector;
